export const createExponentialBackoff = (baseDelay = 1000, maxDelay = 30000, maxRetries = 10) => {
  let retryCount = 0;
  
  const getDelay = () => {
    if (retryCount >= maxRetries) {
      return null;
    }
    const delay = Math.min(baseDelay * (2 ** retryCount), maxDelay);
    retryCount += 1;
    return delay;
  };
  
  const reset = () => {
    retryCount = 0;
  };
  
  const getRetryCount = () => retryCount;
  
  const hasReachedMaxRetries = () => retryCount >= maxRetries;
  
  return {
    getDelay,
    reset,
    getRetryCount,
    hasReachedMaxRetries
  };
};

export const createTokenRetryHandler = (baseDelay = 2000, maxDelay = 60000, maxRetries = 5) => {
  let retryCount = 0;
  let timeoutId = null;
  
  const retry = async (retryFunction) => {
    if (retryCount >= maxRetries) {
      console.error(`Token creation failed after ${maxRetries} attempts`);
      return false;
    }
    
    const delay = Math.min(baseDelay * (2 ** retryCount), maxDelay);
    retryCount += 1;
    
    console.warn(`Token creation retry ${retryCount}/${maxRetries} in ${delay}ms`);
    
    return new Promise((resolve) => {
      timeoutId = setTimeout(async () => {
        try {
          await retryFunction();
          resolve(true);
        } catch (error) {
          console.error(`Token creation retry ${retryCount} failed:`, error);
          const success = await retry(retryFunction);
          resolve(success);
        }
      }, delay);
    });
  };
  
  const reset = () => {
    retryCount = 0;
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };
  
  const getRetryCount = () => retryCount;
  
  const hasReachedMaxRetries = () => retryCount >= maxRetries;
  
  return {
    retry,
    reset,
    getRetryCount,
    hasReachedMaxRetries
  };
};
